<template>
  <v-app>
    <Loader :is-visible="loading"></Loader>

    <div
      v-bind:class="{
        'cidades-empreendedoras-header':
          !this.$route.path.includes('diagnostico'),
      }"
      v-if="!this.$route.path.includes('diagnostico') && isAuthenticated"
    >
      <img src="../public/assets/img/sebrae-logo.png" width="100px" />
    </div>
    <MenuMobile :drawer="drawer" @open="(e) => drawer = e"></MenuMobile>

    <v-app-bar
      app
      class="menu a"
      v-bind:class="{
        'degrade-background-sebrae': isSala,
      }"
      v-if="!this.$route.path.includes('diagnostico') && isAuthenticated"
    >
    <div class="teste d-flex align-center menuPage">
      <div class="mobile">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" :style="{color: isCE?'#fff' : '#000' } "></v-app-bar-nav-icon>
      </div>
     
      <div  class="image" v-if="isSala">
        <selo-logo></selo-logo> 
      </div>
    
      <img
        v-if="
          !isSala &&
          (isFullAdmin || (groupsConfig.visualizarLogo && config.visualizarLogo))
        "
        :src="require(`../public/assets/img/${logo}`)"
        width="100px"
        style="cursor: pointer"
        @click="$router.push('/cidade')"
        class="image"
      >
      </img>

      <div class="desktop">
         <Menu v-if="isAuthenticated" @logout="logout"></Menu>
      </div>
     

      </div>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main
      v-bind:class="{
        logged: !this.$route.path.includes('diagnostico') && isAuthenticated,
      }"
    >
      <router-view />
    </v-main>

    <v-footer
      color="primary"
      class="app-footer"
      v-if="!this.$route.path.includes('diagnostico')"
    >
      <span
        v-if="
          isCE &&
          (!isAuthenticated ||
            isFullAdmin ||
            (groupsConfig &&
              config &&
              groupsConfig.visualizarLogo &&
              config.visualizarLogo))
        "
        >Cidade Empreendedora - SEBRAE / {{ this.$store.state.uf }}</span
      >

      <span
        v-if="
          isSala &&
          (!isAuthenticated ||
            isFullAdmin ||
            (groupsConfig &&
              config &&
              groupsConfig.visualizarLogo &&
              config.visualizarLogo))
        "
        >Selo de Referência em Atendimento SEBRAE -
        {{ this.$store.state.uf }}</span
      >
      <span
        v-if="
          isGov &&
          (!isAuthenticated ||
            isFullAdmin ||
            (groupsConfig &&
              config &&
              groupsConfig.visualizarLogo &&
              config.visualizarLogo))
        "
        >Governança Empreendedora - SEBRAE/{{ this.$store.state.uf }}</span
      >
      <span
        v-if="
          isAT &&
          (!isAuthenticated ||
            isFullAdmin ||
            (groupsConfig &&
              config &&
              groupsConfig.visualizarLogo &&
              config.visualizarLogo))
        "
        >Agentes Territoriais - {{ this.$store.state.uf }}</span
      >
      <span
        v-if="
          isTur &&
          (!isAuthenticated ||
            isFullAdmin ||
            (groupsConfig &&
              config &&
              groupsConfig.visualizarLogo &&
              config.visualizarLogo))
        "
        >Sebrae Turismo - {{ this.$store.state.uf }}</span
      >
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loader from "@/components/Loader";
import Auth from "@/Auth.js";
import Cookies from "@/components/cookies/cookies";
import { atualUfDefinition, EnumAmbienteTipos } from "./helpers/utils";
import SeloLogo from "./modules/seloLogo/seloLogo.vue";
import Swal from "sweetalert2";
import Menu from "./components/layout/menu.vue";
import MenuMobile from "./components/layout/menuMobile.vue";

export default {
  name: "App",
  components: {
    Loader,
    Cookies,
    SeloLogo,
    Menu,
    MenuMobile,
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "isAdmin",
      "loading",
      "uf",
      "logo",
      "isFullAdmin",
      "isIndicadores",
      "isSala",
      "isAT",
      "isGov",
      "isTur",
      "user",
      "groupsConfig",
      "config",
      "isCE"
    ]),
    isDev() {
      return atualUfDefinition.ambient === EnumAmbienteTipos.dev;
    },
    isHlg() {
      return atualUfDefinition.ambient === EnumAmbienteTipos.hlg;
    },
    isProd() {
      return atualUfDefinition.ambient === EnumAmbienteTipos.prod;
    },
  },
  mounted() {
    console.log("isAuthenticated", this.isAuthenticated);
    var token = localStorage.getItem("token") || null;
    var user = JSON.parse(localStorage.getItem("user")) || null;
    var city = localStorage.getItem("city") || null;
    var cityId = localStorage.getItem("cityId") || null;
    var groupsConfig = JSON.parse(localStorage.getItem("groupsConfig")) || null;
    var config = JSON.parse(localStorage.getItem("config")) || null;

    if (city) this.setCityName(city);
    if (cityId) this.setCityId(cityId);
    if (token) {
      this.setToken(token);

      if (user.email === "admin@admin.com.br") {
        user.grupo.verTodosEixos = true;
        user.grupo.visualizaMunicipio = true;
        this.setFullAdmin(true);
      }
    }
    this.setConfigsGlobal({ ...atualUfDefinition, groupsConfig, config, user });
    this.bancoProd();
    this.enableInterceptor();
    this.mudaUf();
  },
  data() {
    return {
      drawer: false,
      href: window.location.href,
    };
  },
  methods: {
    ...mapActions([
      "setToken",
      "setUser",
      "setForcedLogout",
      "setCityName",
      "setCityId",
      "setFullAdmin",
      "setConfigsGlobal",
      "setGroupsConfig",
      "setConfig",
    ]),
    bancoProd() {
      if (
        !this.isProd &&
        atualUfDefinition.banco.indexOf("dev") < 0 &&
        atualUfDefinition.banco.indexOf("hlg") < 0
      )
        Swal.fire({
          title: `Cuidado!`,
          text: `Você está usando um banco de produção em um ambiente de teste, não altere ou cadastre nenhum dado!`,
          confirmButtonColor: "#3085d6",
          confirmButtonText: "Entendi",
        });
    },
    setAmbientName() {
      if (this.isDev) return "Desenvolvimento";
      if (this.isHlg) return "Homologação";
      return;
    },
    getUser() {
      var user = JSON.parse(localStorage.getItem("user"));
      return user;
    },
    getFirstName() {
      if (this.user && this.user.nome) return this.user.nome.split(" ")[0];

      return "";
    },
    mudaUf() {

      setInterval(function () {
        document.documentElement.style.setProperty(
          "--corPrimaria",
          atualUfDefinition.corPrimaria
        );
      }, 100);

      if (atualUfDefinition.isSala) {
        document.title = "Selo Sala do Empreendedor";
        document.getElementById("favicon").href =
          "https://slide1-images.s3.amazonaws.com/public/favicon/selo.ico";
        document
          .querySelector('meta[property="og:title"]')
          .setAttribute("content", "Selo Sala do Empreendedor");
      } else if (atualUfDefinition.isAT) {
        document.title = "Agentes Territoriais";
        document.getElementById("favicon").href =
          "https://slide1-images.s3.amazonaws.com/public/favicon/at.ico";
        document
          .querySelector('meta[property="og:title"]')
          .setAttribute("content", "Agentes Territoriais");
      } else if (atualUfDefinition.isGov) {
        document.title = "Governança Empreendedora";
        document.getElementById("favicon").href =
          "https://slide1-images.s3.amazonaws.com/public/favicon/gov.ico";
        document
          .querySelector('meta[property="og:title"]')
          .setAttribute("content", "Governança Empreendedora");
      } else {
        document.title = "Cidade Empreendedora";
        document
          .querySelector('meta[property="og:title"]')
          .setAttribute("content", "Cidade Empreendedora");
        document.getElementById("favicon").href =
          "https://slide1-images.s3.amazonaws.com/public/favicon/ce.ico";
      }
    },
    enableInterceptor() {
      this.$http.interceptors.request.use(
        (config) => {
          return config;
        },
        (error) => {
          return Promise.reject(error);
        }
      );
      this.$http.interceptors.response.use(
        (response) => {
          return response;
        },
        (err) => {
          console.log("err: ", err);

          const status = (err.response && err.response.status) || 0;

          if (status === 401) {
            Auth.setItem("expired", true);
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/auth/login");
            });
          }

          return Promise.reject(err);
        }
      );
    },
    logout() {
      this.setForcedLogout(true);
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/auth/login");
      });
    },
  },
};
</script>

<style lang="scss">
@import "./style.scss";

.menu{
  position: relative !important;
}


</style>
